<alert></alert>

<div class="page-wrapper section-hr-direct" appUnloadWindow>
  <app-custom-loading></app-custom-loading>
          <router-outlet></router-outlet>
  </div>
<!--   
  <app-outer-footer *ngIf="!loggedInUser"></app-outer-footer> -->